import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-zinc-100 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-display text-2xl font-semibold tracking-tight">
              NovaSite<span className="text-zinc-400">.</span>
            </div>
            <p className="mt-4 text-sm text-zinc-500 max-w-sm leading-relaxed">
              Webdesign aus Karlsruhe — Websites, Online-Shops, Wartung & lokale SEO für Selbstständige und kleine Unternehmen. Aus Karlsruhe, für ganz Deutschland.
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-zinc-500 font-semibold">Navigation</div>
            <ul className="mt-4 space-y-2 text-sm text-zinc-700">
              <li><Link to="/leistungen">Leistungen</Link></li>
              <li><Link to="/preise">Preise</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/ueber-mich">Über mich</Link></li>
              <li><Link to="/kontakt">Kontakt</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-widest text-zinc-500 font-semibold">Kontakt</div>
            <ul className="mt-4 space-y-2 text-sm text-zinc-700">
              <li>kontakt@novasiteworks.de</li>
              <li>+49 157 8809 9385</li>
              <li>Remote · Karlsruhe, Deutschland</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-zinc-100 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} Fabian Winkler · NovaSite. Alle Rechte vorbehalten.</div>
          <div className="flex gap-5 flex-wrap">
            <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-zinc-900">Impressum</Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-zinc-900">Datenschutz</Link>
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-zinc-900">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
